// libs
import styled from 'styled-components'
// icons
import FilterSelectedIconOrigin from '@mui/icons-material/FilterAlt'
import FilterIconOrigin from '@mui/icons-material/FilterAltOutlined'
// utils
import { size } from 'polished'

export const FilterIcon = styled(FilterIconOrigin)<{ color: string }>`
  margin: 0 !important;
  ${size('15px')};

  path {
    fill: ${({ color }) => color};
  }
`

export const FilterSelectedIcon = styled(FilterSelectedIconOrigin)<{ color: string }>`
  margin: 0 !important;
  ${size('15px')};

  path {
    fill: ${({ color }) => color};
  }
`
